import { routes } from '@/app/routing/router'
import { MainView } from './view'

const currentRoute = routes.main

const MainPageRoute = {
  view: MainView,
  route: currentRoute,
}

export { currentRoute, MainPageRoute }
